import React, { useEffect, useRef, useState } from "react";
import {
  calculateTitleLineCounts,
  getDescriptionStyle,
} from "~/Brochure/FoodServiceResources/utilities";

export interface RelatedResource {
  content: string;
  header: string;
  id: number;
  imagePath: string;
  link: string;
  [key: string]: string | number;
}

export interface RelatedResourcesProps {
  relatedResources: RelatedResource[];
}

const BlogRelatedResources = ({
  relatedResources,
}: Readonly<RelatedResourcesProps>) => {
  const titleRefs = useRef<(HTMLHeadingElement | null)[]>([]);
  const [multiLineTitleIndexes, setMultiLineTitleIndexes] = useState<boolean[]>(
    [],
  );

  // Logic is similar to what is used in the CardGrid component
  useEffect(() => {
    // If title is two lines then description should be limited to one
    const lineCounts = calculateTitleLineCounts(titleRefs);
    setMultiLineTitleIndexes(lineCounts);
  }, []);

  const getContentStyle = (index: number) => {
    const isTitleMultipleLines = multiLineTitleIndexes[index] ?? false;
    return getDescriptionStyle(isTitleMultipleLines);
  };

  return (
    <div className="related-resources-container">
      <h3>Related Resources</h3>
      <ul className="related-resources m-0">
        {relatedResources.map((resource: RelatedResource, index) => {
          return (
            <li
              className="related-resources__item"
              key={`resource-${resource.header}`}
            >
              <article>
                <a href={resource.link}>
                  <img
                    src={resource.imagePath}
                    alt=""
                    height="141"
                    width="360"
                    className="related-resources__image"
                  />
                  <div className="related-resources__text-container">
                    <h3
                      className="related-resources__title p-0 mx-0 mt-[2px] mb-[3px] leading-[1rem]"
                      ref={(titleElement) => {
                        titleRefs.current[index] = titleElement;
                      }}
                    >
                      {resource.header}
                    </h3>
                    <p
                      className="related-resources__text"
                      style={getContentStyle(index)}
                    >
                      {resource.content}
                    </p>
                  </div>
                </a>
              </article>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BlogRelatedResources;
